import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-StatisticsShape",
  "use": "svg-icon-StatisticsShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-StatisticsShape\"><path d=\"M3.5 5.5H5a.5.5 0 0 1 .5.5v6.5a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5zm3.5 2h1.5A.5.5 0 0 1 9 8v4.5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5zM10.5 3H12a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5z\" fill=\"#000\" opacity=\".9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol